export default __webpack_public_path__ + "img/header_card.71bf51f0.jpg";